var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-upload",
    {
      attrs: {
        disabled: _vm.disabled,
        action: _vm.fileUploadUrl,
        headers: _vm.myHeaders,
        "on-success": _vm.uploadSuccess,
        "before-upload": _vm.beforeUpload,
        "on-progress": _vm.progressUpload,
        "show-file-list": false,
      },
    },
    [
      _c(
        "el-tooltip",
        { attrs: { content: "上传文件", placement: "top", effect: "light" } },
        [_c("span", { staticClass: "fileIcon" })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/fileUpload.vue?vue&type=template&id=148a7c82&scoped=true&
// module id = null
// module chunks = 